import { AddTask, FilterList, Sort } from "@mui/icons-material";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  type SelectChangeEvent,
  Tooltip,
} from "@mui/material";

import { type TaskFilter } from "../taskUtils";

const tOpen = "Open";
const tCompleted = "Completed";
const tAll = "All";
const tFilter = "Filter";
const tSortOldest = "Sort by oldest first";
const tSortNewest = "Sort by newest first";
const tAddTask = "Add Task";

export interface TaskHeaderProps {
  filter: TaskFilter;
  onFilterChange: (filter: TaskFilter) => void;
  onAddTask?: () => void;
  onSortChange?: () => void;
  showSortButton?: boolean;
  sortNewestFirst?: boolean;
}

export const TaskHeader = ({
  filter,
  onFilterChange,
  onAddTask,
  onSortChange,
  showSortButton = false,
  sortNewestFirst = false,
}: TaskHeaderProps) => {
  const handleFilterChange = (event: SelectChangeEvent) => {
    onFilterChange(event.target.value as TaskFilter);
  };

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" gap={2} flexWrap="wrap">
      <Box display="flex" alignItems="center" gap={2}>
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="task-filter-label">{tFilter}</InputLabel>
          <Select
            labelId="task-filter-label"
            id="task-filter-select"
            value={filter}
            label={tFilter}
            onChange={handleFilterChange}
            startAdornment={<FilterList sx={{ color: "action.active", mr: 1 }} />}
          >
            <MenuItem value="open">{tOpen}</MenuItem>
            <MenuItem value="completed">{tCompleted}</MenuItem>
            <MenuItem value="all">{tAll}</MenuItem>
          </Select>
        </FormControl>
        {showSortButton && onSortChange && (
          <Tooltip title={sortNewestFirst ? tSortOldest : tSortNewest}>
            <IconButton
              size="small"
              color={sortNewestFirst ? "primary" : "default"}
              onClick={onSortChange}
              aria-label={sortNewestFirst ? tSortOldest : tSortNewest}
            >
              <Sort />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      {onAddTask && (
        <Button
          variant="outlined"
          size="small"
          startIcon={<AddTask />}
          onClick={onAddTask}
          sx={{
            "& .MuiButton-startIcon": {
              mr: { sm: 0.5, xs: 0 },
            },
          }}
        >
          <Box sx={{ display: { sm: "block", xs: "none" } }}>{tAddTask}</Box>
        </Button>
      )}
    </Box>
  );
};
